export default function ArrowRight({
  className
}: {
  className?: string
}) {
  return (
    <svg width="100%" height="100%" className={className} viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M62.5554 31.0227C62.5554 47.9113 48.8644 61.6023 31.9758 61.6023C15.0872 61.6023 1.3963 47.9113 1.3963 31.0227C1.3963 14.1341 15.0872 0.443184 31.9758 0.443187C48.8645 0.44319 62.5554 14.1341 62.5554 31.0227Z" stroke="black" strokeWidth="0.886363"/>
      <path d="M27.7968 20.5206C28.4464 19.9601 29.4295 20.0419 29.9776 20.7019L37.2399 29.4471C37.7852 30.1037 37.7852 31.0556 37.2399 31.7122L29.9776 40.4574C29.4295 41.1174 28.4464 41.1992 27.7968 40.6387V40.6387C27.1642 40.093 27.085 39.1413 27.6187 38.4986L33.2537 31.7121C33.7988 31.0555 33.7988 30.1037 33.2537 29.4472L27.6187 22.6607C27.085 22.018 27.1642 21.0663 27.7968 20.5206V20.5206Z" fill="black"/>
    </svg>
  )
}
